// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 464 ? "sww" : chunkId) + "." + {"464":"9fa461e2","646":"d0aa27c3"}[chunkId] + ".chunk.js";
};